import React from 'react'



//before//launch//after


const cardsTags = {
    '2051': {
      external: false,
      monetization: ['microtransactions'],
      tag: ['after'],
      platform: ['win', 'web',],
    },
    '2052': {
      external: true,
      monetization: ['microtransactions'],
      tag: ['after'],
      platform: ['win'],
    },
    '12087': {
      external: true,
      monetization: ['subscriptions'],
      tag: ['before'],
      platform: ['win', 'web', 'console', 'mobile'],
    },
    '12090': {
      external: true,
      monetization: ['microtransactions', 'premium', 'subscriptions'],
      tag: ['launch'],
      platform: ['win', 'web', 'console', 'mobile'],
    },
    '12251': {
      external: true,
      monetization: ['microtransactions', 'premium'],
      tag: ['before'],
      platform: ['win', 'web', 'console', 'mobile'],
    },
    '12252': {
      external: true,
      monetization: ['microtransactions'],
      tag: ['launch'],
      platform: ['win', 'web', 'console', 'mobile'],
    },
    '12253': {
      external: true,
      monetization: ['subscriptions'],
      tag: ['after'],
      platform: ['win', 'web', 'console', 'mobile'],
    },
    '12254': {
      external: true,
      monetization: ['microtransactions', 'premium', 'subscriptions'],
      tag: ['before'],
      platform: ['win', 'web', 'console', 'mobile'],
    },
    '12255': {
      external: false,
      monetization: ['microtransactions', 'premium'],
      tag: ['launch'],
      platform: ['win', 'web', 'console', 'mobile'],
    },
    '12261': {
      external: false,
      monetization: ['microtransactions'],
      tag: ['before'],
      platform: ['win', 'web', 'console', 'mobile'],
    }
  }





export const addTags = (data) => data.map((oneSol, index) => ({
          ...oneSol,
          ...cardsTags[oneSol['id']]
    })
)


export const prepareData = (
    data = cardsProduction,
    onlyExternal = true,
  ) => {

    data = addTags(data);
    console.log('data = ', data[0]);


    if (onlyExternal) {
      data = data.filter((oneSol) => oneSol['external'] ? true : false)
    }


    return data

  }




export const cardsProduction = [
  {
      "id": 2051,
      "salesCardId": 8,
      "imageUrl": "\/\/cdn3.xsolla.com\/img\/misc\/images\/36f8e5c1fca71f5a393cf35a26b0d637.jpg",
      "badgeText": "INCREASE PAYMENTS COVERAGE",
      "title": "Boost revenue by expanding payments in South Korea",
      "description": "Be among the first companies to adopt advanced tech and conquer the Korean market with new digital wallets like Toss, NaverPay, and KakaoPay.",
      "learnMoreUrl": "https:\/\/xsolla.com\/blog\/payments\/1154\/boost-revenue-by-unlocking-south-korea",
      "integrationTimeText": "Setup time: less than 3 minutes",
      "callToAction": null,
      "proposalText": "You see this card because you can earn more by selling in South Korea",
      "postponed": false,
      "project_id": 43087,
      "project_name": "project cta"
  },
  {
      "id": 2052,
      "salesCardId": 8,
      "imageUrl": "\/\/cdn3.xsolla.com\/img\/misc\/images\/36f8e5c1fca71f5a393cf35a26b0d637.jpg",
      "badgeText": "INCREASE PAYMENTS COVERAGE",
      "title": "Boost revenue by expanding payments in South Korea",
      "description": "Be among the first companies to adopt advanced tech and conquer the Korean market with new digital wallets like Toss, NaverPay, and KakaoPay.",
      "learnMoreUrl": "https:\/\/xsolla.com\/blog\/payments\/1154\/boost-revenue-by-unlocking-south-korea",
      "integrationTimeText": "Setup time: less than 3 minutes",
      "callToAction": null,
      "proposalText": "You see this card because you can earn more by selling in South Korea",
      "postponed": true,
      "project_id": 43087,
      "project_name": "project cta"
  },
  {
      "id": 12087,
      "salesCardId": 38,
      "imageUrl": "\/\/cdn3.xsolla.com\/img\/misc\/images\/4fbf7b3f79eba0df768123c983867e7c.jpg",
      "badgeText": "ENGAGE YOUR PLAYERS",
      "title": "Build direct relationships with players to grow your business",
      "description": "Create a loyal community, communicate with your players, and keep control of your cross-platform gamers\u2019 data with our comprehensive distribution tools to represent your game.",
      "learnMoreUrl": "https:\/\/xsolla.com\/blog\/publishing-suite\/946\/your-game-your-platform-your-players",
      "integrationTimeText": "Setup time: 8 hours",
      "callToAction": null,
      "proposalText": "You see this card because your business can grow by using our services",
      "postponed": false,
      "project_id": 43087,
      "project_name": "project cta"
  },
  {
      "id": 12090,
      "salesCardId": 39,
      "imageUrl": "\/\/cdn3.xsolla.com\/img\/misc\/images\/ebf75d742d5797bf64381a42cfad9b77.jpg",
      "badgeText": "REACH THE WORLD",
      "title": "Connect with 650K+ influencers and 50+ affiliate networks worldwide",
      "description": "Create & distribute revenue share programs to influencers and affiliate networks, while maintaining full control over all your relationships and data in one central place.",
      "learnMoreUrl": "https:\/\/developers.xsolla.com\/doc\/partner-network\/",
      "integrationTimeText": "Setup time: 10 minutes",
      "callToAction": {
          "title": "Get started",
          "url": null,
          "isExternal": null
      },
      "proposalText": "You see this card because your business can grow by using our services",
      "postponed": false,
      "project_id": 43087,
      "project_name": "project cta"
  },
  {
      "id": 12251,
      "salesCardId": 13,
      "imageUrl": "\/\/cdn3.xsolla.com\/img\/misc\/images\/caf4c87d582729a89bc0e84dd47d7d8e.jpg",
      "badgeText": "LOCAL COMPLIANCE",
      "title": "Accept payments and stay compliant in the USA",
      "description": "Offload the cost, risk, and complexity of selling your video games in USA by having Xsolla act as your Merchant of Record. We\u2019ll handle calculation, collection & payment of the sales tax in all States.",
      "learnMoreUrl": "https:\/\/xsolla.com\/blog\/payments\/480\/online-sales-tax-in-the-usa-what-you-need-to-know",
      "integrationTimeText": "Setup time: less than 3 minutes",
      "callToAction": null,
      "proposalText": "You see this card because you can earn more by selling in the USA",
      "postponed": false,
      "project_id": 43087,
      "project_name": "project cta"
  },
  {
      "id": 12252,
      "salesCardId": 17,
      "imageUrl": "\/\/cdn3.xsolla.com\/img\/misc\/images\/c41b9a78d840f34d84381ead01978d7f.jpg",
      "badgeText": "SELL DIRECTLY TO PLAYERS",
      "title": "Distribute games more easily with flexible simplicity",
      "description": "Deliver game keys for every platform where your title is available and give you more control over where and how you sell.",
      "learnMoreUrl": "https:\/\/xsolla.com\/products\/buy-button",
      "integrationTimeText": null,
      "callToAction": {
          "title": "GET STARTED",
          "url": null,
          "isExternal": null
      },
      "proposalText": "You see this card because you showed interest at Gamescom 2019",
      "postponed": false,
      "project_id": 43087,
      "project_name": "project cta"
  },
  {
      "id": 12253,
      "salesCardId": 16,
      "imageUrl": "\/\/cdn3.xsolla.com\/img\/misc\/images\/52f1edb194f4e7eb480db6752a7f8dd0.jpg",
      "badgeText": "CREATE CONSISTENT REVENUE",
      "title": "Turn your players into monthly subscribers",
      "description": "Subscriptions are an effective and fast-growing form of monetization that creates revenue with low overhead, inspires player loyalty, and generates predictable income streams you can rely on when planning long-term updates.",
      "learnMoreUrl": "https:\/\/xsolla.com\/blog\/monetization\/1136\/generating-subscription-revenue-in-video-games",
      "integrationTimeText": null,
      "callToAction": null,
      "proposalText": "Because you can earn more from your game with subscriptions",
      "postponed": false,
      "project_id": 43087,
      "project_name": "project cta"
  },
  {
      "id": 12254,
      "salesCardId": 12,
      "imageUrl": "\/\/cdn3.xsolla.com\/img\/misc\/images\/d998708d9858a7e8297f84751bdbc1df.png",
      "badgeText": "UNTAPPED PAYMENT METHODS",
      "title": "Earn more from cash-paying gamers",
      "description": "Push payments let you reach new gamers in more places with Cash Kiosks, ATMs, and digital marketplaces around the globe, including banking applications.",
      "learnMoreUrl": "https:\/\/xsolla.com\/blog\/payments\/777\/grow-with-push-payments",
      "integrationTimeText": "Setup time: 30 minutes",
      "callToAction": null,
      "proposalText": "You see this card because you could earn more by accepting push payments",
      "postponed": false,
      "project_id": 43087,
      "project_name": "project cta"
  },
  {
      "id": 12255,
      "salesCardId": 31,
      "imageUrl": "\/\/cdn3.xsolla.com\/img\/misc\/images\/6bf5390918f74e6937541e5b07353e20.jpg",
      "badgeText": "COMPLY WHEREVER YOU SELL",
      "title": "Easily comply with all taxes and laws everywhere",
      "description": "Offload the tedious, specialized background work of global sales, so your company can focus on improving its product and increasing revenue.",
      "learnMoreUrl": "https:\/\/drive.google.com\/a\/xsolla.com\/file\/d\/1DO3dzizWf3D5zhQL5s27SJy8r-3bDdsf\/view?usp=sharing",
      "integrationTimeText": "Setup time: less than 5 minutes",
      "callToAction": {
          "title": "Learn more",
          "url": null,
          "isExternal": null
      },
      "proposalText": "Because you can easily make compliant sales and generate more revenue",
      "postponed": false,
      "project_id": 43087,
      "project_name": "project cta"
  },
  {
      "id": 12261,
      "salesCardId": 10,
      "imageUrl": "\/\/cdn3.xsolla.com\/img\/misc\/images\/82462819c6beec31f97ee246d4577be9.jpg",
      "badgeText": "ENTER NEW TERRITORIES",
      "title": "Grow your audience in Japan and earn more",
      "description": "Japan is a country of 70 million gamers. Home to industry giants, like Nintendo and Sega, video games will continue to grow as part of the Japanese economy in the years to come. Don\u2019t miss out on entering this powerful market!",
      "learnMoreUrl": "https:\/\/xsolla.com\/blog\/payments\/1166\/grow-your-audience-in-japan_market",
      "integrationTimeText": "Setup time: less than 3 minutes",
      "callToAction": null,
      "proposalText": "You see this card because you can earn more by selling in Japan",
      "postponed": false,
      "project_id": 43087,
      "project_name": "project cta"
  }
]